<template>
  <div class="row mb-3 header-edit">
    <div class="col-12 col-lg-11 col-xl-11 col-md-11 pr-0 fees-percentages-wrapper">
      <div
        class="fees-percentages-orange position-relative flex-column flex-lg-row flex-xl-row flex-md-row"
      >
        <div class="flex" :class="jobId ? 'col-5' : 'col-8'">
          <span class="mod-icon-weight d-inline-block mr-3" />
          <p>Should cluster fee and percentages be changed for this move?</p>
        </div>
        <div :class="jobId ? 'col-2' : 'col-4'">
          <p v-if="enabled" :class="loading ? 'disabled' : ''" @click="!loading && toggleChangeFeesPercentages()">
            <span>No</span>
            <label class="switch" @click.prevent>
              <input type="checkbox" :checked="data.fee_change" />
              <span class="check-slider round" />
            </label>
            <span :class="data.fee_change ? 'yes-active' : ''">Yes</span>
          </p>
          <p v-else-if="leadId">
            This lead has already been booked, please make adjustments on job.
          </p>
        </div>
        <div v-if="jobId" class="col-5 inputs">
          <div class="row" v-show="data.fee_change">
            <div class="col-4">
              <div
                class="select-wrap amount-wrap"
                :class="!editing ? 'border-0' : ''"
              >
                <label>Cluster fee</label>
                <span class="dollar">$</span>
                <input
                  v-model="clusterFeeValue"
                  type="text"
                  class="form-control"
                  :disabled="(!editing)"
                />
              </div>
            </div>
            <div class="col-4">
              <div
                class="select-wrap amount-wrap"
                :class="!editing ? 'border-0' : ''"
              >
                <label>Cluster %</label>
                <span class="percent">%</span>
                <input
                  v-model="clusterPercentValue"
                  type="text"
                  class="form-control"
                  :disabled="(!editing)"
                />
              </div>
            </div>
            <div class="col-4">
              <button
                v-if="!editing"
                type="button"
                class="btn btn-primary"
                @click="editing = true"
              >
                Edit
              </button>
              <button
                v-else
                type="button"
                class="btn btn-primary"
                @click="saveFeesPercentages"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';

export default {
  name: 'FeesPercentages',
  props: {
    clusterFee: {
      type: Number,
      default: 0,
    },
    clusterPercent: {
      type: Number,
      default: 0,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    feeChange: {
      type: Boolean,
      default: false,
    },
    jobId: {
      type: Number,
      default: null,
    },
    leadId: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {
        cluster_fee: this.clusterFee,
        cluster_percent: this.clusterPercent,
        fee_change: this.feeChange,
      },
      editing: false,
    };
  },
  computed: {
    clusterFeeValue: {
      get() {
        return this.clusterFee;
      },
      set(newValue) {
        this.data.cluster_fee = newValue;
        return newValue;
      },
    },
    clusterPercentValue: {
      get() {
        return this.clusterPercent;
      },
      set(newValue) {
        this.data.cluster_percent = newValue;
        return newValue;
      },
    },
  },
  methods: {
    saveFeesPercentages() {
      this.editing = false;
      const url = this.jobId
        ? `/jobs/${this.jobId}/fees-percentages`
        : `/leads/${this.leadId}/fees-percentages`;
      axios
        .patch(url, this.data)
        .then(() => {
          this.$emit(this.jobId ? 'getJob' : 'getLead');
          toastr.success('Cluster fees & percentages updated successfully.');
        })
        .catch(() => {
          this.editing = true;
          toastr.error('Failed to update cluster fees & percentages.');
        });
    },
    toggleChangeFeesPercentages() {
      this.data.fee_change = !this.data.fee_change;
      if (this.leadId || !this.data.fee_change) {
        this.saveFeesPercentages();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fees-percentages-orange {
  background-color: #fffcf4;
  border: solid 1px #ffab00;
  border-radius: 4px;
  margin-left: 30px;
  min-height: 74px;
  display: flex;
  align-items: center;
  padding: 14px 0;
  width: 95%;

  p {
    display: flex;
    align-items: center;

    .switch {
      margin-left: 16px;
    }

    .yes-active {
      color: #2962ff;
    }
  }
  .inputs {
    transition: all 0.4s ease-in-out;
  }
  .select-wrap {
    min-height: 42px;
  }
  .amount-wrap span {
    top: 20px;
  }
  .select-wrap .form-control {
    height: 42px;
  }
  .select-wrap .form-control:disabled {
    opacity: initial;
  }
  .btn-primary {
    width: inherit;
  }
}
@media (max-width: 1820px) {
  .header-edit .fees-percentages-orange {
    width: 94%;
  }
}

@media (max-width: 1700px) {
  .header-edit .fees-percentages-orange {
    width: 93%;
  }
}

@media (max-width: 1600px) {
  .header-edit .fees-percentages-orange {
    width: 91%;
  }
}

@media (max-width: 1450px) {
  .header-edit .fees-percentages-orange {
    width: 90%;
  }
}

@media (max-width: 1360px) {
  .header-edit .fees-percentages-orange {
    width: 88%;
  }
}
@media (max-width: 450px) {
  .header-edit .fees-percentages-orange {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FeesPercentages.vue